import React from 'react';
import * as luxon from 'luxon';
import Stack from '../v2BaseComponents/Stack';
import { View } from 'react-native';
import { colors } from '../../utils/theme';
import Text, { TextColor } from '../v2BaseComponents/Text';
import { getSpacing } from '../../utils/spacing';

interface LargeDateDisplayProps {
    date?: string | null;
    backgroundColor?: string;
    textColor?: TextColor;
}

const getSplitDate = (date?: string | null) => {
    if (!date) return null;
    const dt = luxon.DateTime.fromISO(date);
    if (!dt.isValid) return null;
    return {
        month: dt.monthShort,
        day: dt.day,
        year: dt.year,
    };
};

const LargeDateDisplay: React.FC<LargeDateDisplayProps> = ({ date, backgroundColor, textColor }) => {
    const splitDate = getSplitDate(date);

    if (!splitDate) return null;

    return (
        <Stack vertical align="center" justify="center" style={{ marginRight: getSpacing(2.5) }}>
            <Text variant="body-2">{splitDate.month!.toUpperCase()}</Text>
            <View
                style={{
                    height: 52,
                    width: 57,
                    backgroundColor: backgroundColor || colors['Primary-Light'],
                    borderRadius: 3,
                    justifyContent: 'center',
                    alignContent: 'center',
                }}
            >
                <Text variant="h1" color={textColor || 'White'} alignText="center">
                    {`${splitDate.day}`}
                </Text>
            </View>
            <Text variant="body-2">{`${splitDate.year}`}</Text>
        </Stack>
    );
};

export default React.memo(LargeDateDisplay);
